/* TH Sepet — sepet önerilerinden tek tıkla ekleme (Dawn sepet çekmecesiyle çalışır) */
if (!customElements.get('th-cart-upsell')) {
  customElements.define(
    'th-cart-upsell',
    class ThCartUpsell extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-th-add]');
          if (button) {
            event.preventDefault();
            this.add(button);
          }
        });
        // Varyant seçimi Dawn'un adet güncelleme dinleyicisine ulaşmasın
        this.addEventListener('change', (event) => event.stopPropagation());
      }

      async add(button) {
        if (button.disabled) return;
        const card = button.closest('[data-th-card]');
        const select = card && card.querySelector('[data-th-variant]');
        const errorEl = card && card.querySelector('.th-upsell__error');
        const variantId = Number(select ? select.value : button.dataset.variantId);
        if (!variantId) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const body = { id: variantId, quantity: 1 };
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');
          body.sections_url = window.location.pathname;
        }

        const label = button.textContent;
        button.disabled = true;
        button.textContent = '…';
        if (errorEl) errorEl.hidden = true;

        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();

          if (data.status) {
            if (errorEl) {
              errorEl.textContent = data.description || data.message || 'Eklenemedi';
              errorEl.hidden = false;
            }
            button.disabled = false;
            button.textContent = label;
            return;
          }

          if (cartDrawer && data.sections) {
            cartDrawer.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'th-upsell', productVariantId: variantId, cartData: data });
          }
        } catch (error) {
          console.error(error);
          if (errorEl) {
            errorEl.textContent = 'Bağlantı hatası, tekrar dene';
            errorEl.hidden = false;
          }
          button.disabled = false;
          button.textContent = label;
        }
      }
    }
  );
}